export const Box = ({
  children,
  className = "",
  size = "lg",
  bg = "white",
}: {
  children: React.ReactNode;
  className?: string;
  size?: "lg" | "md" | "sm" | "none";
  bg?: string;
}) => {
  const cls = () => {
    if (size === "none") return "p-0";
    if (size === "sm") return "p-2";
    if (size === "md") return "p-4";
    return "p-7";
  };

  return (
    <div
      className={`bg-${bg} ${cls()} shadow border border-black-100 rounded-lg ${className}`}
    >
      {children}
    </div>
  );
};

export const BoxGroup = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex flex-col gap-4">{children}</div>;
};
